import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const VietnamFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				width='20'
				height='14'
				rx='2'
				fill='white'
			/>
			<mask
				id='mask0_2332_16230'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					width='20'
					height='14'
					rx='2'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask0_2332_16230)'>
				<rect
					width='20'
					height='14'
					fill='#EA403F'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M10.0006 8.63805L7.48148 10.3979L8.41093 7.50622L5.9246 5.70218L9.01812 5.67488L10.0006 2.80005L10.983 5.67488L14.0765 5.70218L11.5902 7.50622L12.5196 10.3979L10.0006 8.63805Z'
					fill='#FFFE4E'
				/>
			</g>
		</svg>
	);
};

export default VietnamFlagIcon;
